import React, { useEffect, useState } from "react";
import { SuccessAlert, ErrorAlert } from "../middleware/AlertMsg";
import { getReq, postReq } from "../middleware/AxiosApisCall";
import DataList from "../Partials/DataList";
import BulkUpload from "../Partials/BulkUpload";
import { useNavigate } from "react-router-dom";
import { AiFillDelete } from "react-icons/ai";
import Loading from "../Loading";
// import TableDataWithPagination from "../Partials/TableDataWithPagination";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,TablePagination
} from '@mui/material';
import {HeaderTableCell,StyledTableRow,StyledTableCell} from '../Partials/TableStyle'
function PurchaseStock() {
  const [singleProduct, setSingleProduct] = useState({
    product: "",
    productQuantity: "",
    sellingPrice: "",
    totalPrice: "",
  });
  const [stock, setStock] = useState({
    supplier: "",
    warehouse: "",
    products: [],
    invoiceNumber: "",
    date: "",
    // GRN_Number: '',
    // gstName: ''
  });
  const [bulk, setBulk] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  // const [productsList, setProductsList] = useState([]);
  // const [selected, setSelected] = useState(null);
  const path = "purchaseStock";
  const ComponentName = "Purchase";
  // const ProductListPath = "Product/Datalist";
  const navigate = useNavigate();

  const fetchProductsData = async () => {
    const response = await getReq("Product/Datalist");
    setAllProducts(response.data);
  };
  useEffect(() => {
    fetchProductsData();
  }, []);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setStock((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleProduct = (e) => {
    const { name, value } = e.target;
    setSingleProduct((prevFormData) => ({
      ...prevFormData,
      [name]: value,
      totalPrice:
        name === "productQuantity"
          ? (singleProduct.sellingPrice * value).toFixed(2)
          : 0,
    }));
  };

  const handleProductAdd = async (e) => {
    e.preventDefault();
    const { product, productQuantity, sellingPrice } = singleProduct;

    const checkProductfromMasterProductList = allProducts.find(
      (item) => item.productname === product
    );

    if (!checkProductfromMasterProductList) {
      alert("product is not available in product list ..!");
      setSingleProduct({
        product: "",
        productQuantity: "",
        sellingPrice: "",
        totalPrice: "",
      });
      return;
    }
    const checkProduct = stock.products.find(
      (item) => item.product === product
    );
    if (checkProduct) {
      alert("product is already addded ..!");
      setSingleProduct({
        product: "",
      });
      return;
    }
    if (product === "" || productQuantity === "" || sellingPrice === "") {
      return alert(" Fields Should not Empty ..!");
    } else {
      const productsArray = [...stock.products, singleProduct];
      setStock({
        ...stock,
        products: productsArray,
      });
      setSingleProduct({
        product: "",
        productQuantity: "",
        sellingPrice: "",
        totalPrice: "",
      });
    }
  };
  // this function is used to calculate total Amount of all products
  const totalAmountValue = () => {
    let total = 0;
    for (const product of stock.products) {
      total += parseFloat(product.totalPrice);
    }
    setTotalAmount(total);
  };

  useEffect(() => {
    totalAmountValue();
  }, [stock.products]);

  const handleSubmit = async () => {
    const { supplier, warehouse, invoiceNumber } = stock;
    if (supplier === "" || warehouse === "" || invoiceNumber === "") {
      return alert("Please Select All Fields..!");
    }
    const shouldSubmit = window.confirm(
      "Are you sure to Submit these Purchase items ?"
    );
    if (!shouldSubmit) {
      return;
    }
    setLoading(true);
    const response = await postReq(path, stock);
    if (response.success) {
      setLoading(false);
      SuccessAlert({
        title: `Add ${ComponentName}`,
        message: `${ComponentName} successfully`,
      });
      setStock({
        supplier: "",
        warehouse: "",
        products: [],
        invoiceNumber: "",
        date: "",
        // GRN_Number: "",
        // gstName: "",
      });
    } else {
      setLoading(true);
      ErrorAlert({ title: `Add ${ComponentName}`, message: response.msg });
      setLoading(false);
    }
  };

  const handleDelete = (id) => {
    const updated = stock.products.filter((item, index) => index !== id);
    setStock({
      ...stock,
      products: updated,
    });
  };
  const { product, productQuantity, sellingPrice, totalPrice } = singleProduct;

  // GRN_Number, gstName ,future use

  const { supplier, warehouse, invoiceNumber, date } = stock;
  return (
    <React.Fragment>
      {loading ? (
        <Loading />
      ) : (
        <div className="add-user-container">
          <div className="headingdiv">
            <span className="componet-title"></span>
            <div>
              <button onClick={() => navigate(-1)}>Back</button>
            </div>
          </div>
          <div className="option-btn">
            <button
              onClick={() => {
                navigate("../purchasestocklist");
              }}
            >
              Purchase Stock List
            </button>
            <button
              onClick={() => {
                setBulk(!bulk);
              }}
            >
              {bulk ? "Add Single purchase" : "Upload Bulk Purchase"}
            </button>
          </div>

          {bulk ? (
            <BulkUpload path={"PurchaseStock"} ComponentName={"Purchase"} />
          ) : (
            <>
              <div className="add-user-container">
                <div className="componet-sub-title">
                  <span>
                    {/* {par
                  ? `Update ${ComponentName} Details`
                  : `Add ${ComponentName} Details`} */}
                    Purchase Stock
                  </span>
                </div>

                <form className="flex-col">
                  {/*  */}
                  <div className="input-lable-v-div">
                    <DataList
                      name={"supplier"}
                      value={supplier}
                      path={"listSupplier"}
                      option={"supplierName"}
                      handleChange={handleChange}
                      heading={"Supplier"}
                    />
                  </div>
                  <div className="input-lable-v-div">
                    <DataList
                      name={"warehouse"}
                      value={warehouse}
                      path={"getAllWarehouses"}
                      option={"wareHouseName"}
                      handleChange={handleChange}
                      heading={"Warehouse"}
                    />
                  </div>
                  <div className="input-lable-v-div">
                    <label htmlFor="contactPerson">Invoice Number</label>
                    <input
                      type="text"
                      name="invoiceNumber"
                      value={invoiceNumber}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="input-lable-v-div">
                    <label htmlFor="contactPerson">Date</label>
                    <input
                      type="date"
                      name="date"
                      value={date}
                      onChange={handleChange}
                    />
                  </div>

                  {/* <div className="input-lable-v-div">
                <label htmlFor="contactPerson">GRN Number</label>
                <input
                  type="number"
                  name="GRN_Number"
                  value={GRN_Number}
                  onChange={handleChange}
                />
              </div>
              <div className="input-lable-v-div">
                <DataList
                  name={"gstName"}
                  value={gstName}
                  path={"tax"}
                  option={"hsn_Code"}
                  handleChange={handleChange}
                  heading={"HSN Code"}
                />
              </div> */}
                </form>
              </div>

              <div className="add-user-container">
                <div className="componet-sub-title" style={{ margin: "15px" }}>
                  <span>Add Product Details</span>
                </div>
                <form
                  className="flex-col"
                  style={{ marginLeft: "15px" }}
                  onSubmit={handleProductAdd}
                >
                  <div className="input-lable-v-div">
                    <label htmlFor="productName">Product</label>
                    <input
                      name="product"
                      onChange={handleProduct}
                      list="products"
                      value={product}
                      placeholder={"Select..."}
                      autoComplete={"off"}
                      style={{ textAlign: "left" }}
                    />
                    <datalist id="products">
                      {allProducts.length > 0 ? (
                        allProducts.map((item, i) => {
                          return (
                            //
                            <option key={item._id} value={item.productname}>
                              {item.productname}
                            </option>
                          );
                        })
                      ) : (
                        <option>{"Products not found"}</option>
                      )}
                    </datalist>
                  </div>
                  <div className="input-lable-v-div">
                    <label htmlFor="contactPerson">Purchase Price</label>
                    <input
                      type="number"
                      name={"sellingPrice"}
                      value={sellingPrice}
                      onChange={(e) => handleProduct(e)}
                    />
                  </div>
                  <div className="input-lable-v-div">
                    <label htmlFor="supplierAddress">Product quantity</label>
                    <input
                      type="number"
                      name={"productQuantity"}
                      value={productQuantity}
                      onChange={(e) => handleProduct(e)}
                    />
                  </div>
                  <div className="input-lable-v-div">
                    <label htmlFor="contactPerson">Total Price</label>
                    <input
                      type="number"
                      name="totalPrice"
                      value={totalPrice}
                      readOnly
                    />
                  </div>
                  <div className="input-lable-h-div">
                    <button className="submit-btn" type="submit">
                      Add
                    </button>
                  </div>
                </form>
              </div>

              {stock.products?.length > 0 ? (
                <div>
                  <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <StyledTableRow>
                        <HeaderTableCell>Sl no</HeaderTableCell>
                        <HeaderTableCell>Product</HeaderTableCell>
                        <HeaderTableCell>Qty</HeaderTableCell>
                        <HeaderTableCell>Price</HeaderTableCell>
                        <HeaderTableCell>Total Price</HeaderTableCell>
                        <HeaderTableCell>Action</HeaderTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {stock.products.map((item, i) => (
                         <StyledTableRow key={item.product} sx={{
                          backgroundColor: i % 2 === 0 ? '#f5f5f5' : 'white',
                          }}>
                          <StyledTableCell align='center'>{i + 1}</StyledTableCell>
                          <StyledTableCell>{item.product}</StyledTableCell>
                          <StyledTableCell align='right'>{item.productQuantity}</StyledTableCell>
                          <StyledTableCell align='right'>{item.sellingPrice}</StyledTableCell>
                          <StyledTableCell align='right'>{item.totalPrice}</StyledTableCell>
                          <StyledTableCell align='center'>
                            {" "}
                            <AiFillDelete
                              value={item.id}
                              onClick={() => handleDelete(i)}
                              className="Delete-icon"
                            />
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                  </TableContainer>
                  <button
                    style={{ marginLeft: "80px" }}
                    className="submit-btn"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              ) : (
                <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    <StyledTableRow>
                      <HeaderTableCell align='center'   style={{ color: "white" }}>No data</HeaderTableCell>
                    </StyledTableRow>
                  </TableBody>
                </Table>
                </TableContainer>
              )}
              <h4 style={{ textAlign: "right", marginRight: "213px" }}>
                Total Amount: ₹
                {(Math.round(totalAmount * 100) / 100).toFixed(2)}
              </h4>
            </>
          )}
        </div>
      )}
      {/* <div className="table_container-div">
        <TableDataWithPagination path={purchaselist} key={tableRefresh} />
      </div> */}
    </React.Fragment>
  );
}

export default PurchaseStock;
